import { useQuery } from "react-query";
import { getScorecardStatus } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";


export const useScorecardStatus = () => {
    const { data, isLoading, refetch } = useQuery(
        "GetScorecardStatus",
        getScorecardStatus,
        {
            refetchOnWindowFocus: false,
        }
    );

    return { data, isLoading, refetch };
};